<template>
  <section class="FiltersBlockMobile" :class="[ alert ? 'FiltersBlockMobile_with' : '' ]">

    <div class="FiltersBlockMobile_wrapper" @click="openPanel">
      <p>Filtrer les résultats <span v-if="filtersSlugs.length >= 1">({{ filtersSlugs.length }})</span></p>
      <button class="FiltersBlockMobile_filters_choices_reset" @click="reset" :style="{ visibility: filtersSlugs.length > 0 ? 'visible' : 'hidden'}">Réinitialiser<i class="far fa-redo"></i></button>
    </div>

    <section class="Panel" v-if="panelOpen" ref="panel">

      <transition name="fade" appear><div class="Panel_cache" @click="closePanel" v-if="isShow"></div></transition>

      <transition name="fade" appear>
        <button class="Panel_close" @click="closePanel" v-if="isShow"><i class="fal fa-times"></i></button>
      </transition>

      <i class="Load fad fa-spinner-third" v-if="onLoad"></i>

      <transition name="panel" appear>
        <div class="Panel_wrapper" ref="wrapper" v-if="isShow">
          <p>Filtrer les résultats <span class="alert">(2 filtres maximum)</span></p>
          <button class="FiltersBlockMobile_filters_choices_reset" @click="reset" :style="{ visibility: filtersSlugs.length > 0 ? 'visible' : 'hidden'}">Réinitialiser<i class="far fa-redo"></i></button>
          <div class="FiltersBlockMobile_filters_choices_field" v-for="(row, index) in filters" :key="index" :class="{ 'FiltersBlockMobile_filters_choices_field_buttons': row.type == 'buttons' }">
            <h5 v-if="row.name.length > 2">{{ row.name }}</h5>

            <div class="FiltersBlockMobile_filters_choices_field_select" v-if="row.type == 'select'" :class="{ 'FiltersBlockMobile_filters_choices_field_select_selected': selectActive }">
              <i class="FiltersBlockMobile_filters_choices_field_select_arrow fas fa-sort-down"></i>
              <i class="FiltersBlockMobile_filters_choices_field_select_picto fas fa-map-marker-alt"></i>
              <select class="Cta Cta_line Cta_select" :class="{ 'Cta_selected': selectActive }" @change="toggleFilter" data-index="9" v-if="$tools.isTouchDevice()" ref="select">
                <option selected value="remove" disabled>Choisir une région</option>
                <option v-for="(filter, index) in row.filters" :data-slug="filter.slug" data-index="9" :key="index" @click="toggleFilter">{{ filter.name }}</option>
              </select>

              <v-select class="Cta Cta_line Cta_select" :class="{ 'Cta_selected': selectActive }" ref="vselect" v-else :dir="'auto'" :clearable="false" :searchable="false" :options="row.filters" label="name" placeholder="Choisir une région" v-model="select" @input="toggleFilter">
                <template slot="option" slot-scope="option">
                  <li v-html="option.name" :data-slug="option.slug" data-index="9"></li>
                </template>
              </v-select>
            </div>

            <button v-else class="Cta Cta_line" v-for="(filter, i) in row.filters" :data-slug="filter.slug" :data-index="row.id" :key="i" @click="toggleFilter" :data-i="i"  :class="{ 'Cta_selected': filtersSlugs.some(e => e.slug === filter.slug) }">{{ filter.name }}</button>

          </div>
        </div>
      </transition>

    </section>

  </section>
</template>

<script>
  import filtersBlock from '@/mixins/filtersBlock'

  export default {
    name:"FiltersBlockMobile",
    props: [ 'filters' ],
    mixins: [ filtersBlock ],
    data() {
      return {
        panelOpen: false,
        isShow: false
      }
    },
    watch: {

    },
    methods: {
      openPanel()
      {
        this.panelOpen = true
        this.$nextTick( () => {
          this.$refs.panel.style.zIndex = '1'
        })
        this.$tools.disableScroll()
        this.isShow = true
      },
      closePanel()
      {
        this.isShow = false
        setTimeout( () => {
          this.panelOpen = false
          this.$tools.enableScroll()
        }, 500)
      }
    },
    beforeDestroy()
    {
      if(this.panelOpen)
        this.$tools.enableScroll()
    },
  }
</script>

<style lang="stylus">
.FiltersBlockMobile

  width 100%
  height 70px
  position fixed
  bottom 0px
  left 0px
  z-index 10000
  right 0px
  background-color white
  box-shadow: 0 2px 24px 0 rgba(0,0,0,0.10);

  .alert

    color $blue

  &_with

    .alert

      color $red

  .Panel

    z-index -1

    &_close

      top 0px

    &_wrapper

      top 0px
      padding 25px 25px

    .FiltersBlockMobile_filters_choices_reset

      margin-bottom 30px
      margin-top 10px

  .Load

    position absolute
    font-size 18px
    color $red
    top 50px
    right 23px
    z-index 10000
    animation rotate 1s linear infinite

    @media $small

      right 15px

  &_wrapper

    display flex
    height 100%
    width 100%
    cursor pointer
    flex-direction row
    align-items center
    justify-content space-between
    padding 0px 25px
    box-sizing border-box

  p

    font-family: $f-title
    font-weight 500
    font-size: 17px;
    color: $blue
    letter-spacing: -0.3px;
    line-height: 22px;
    margin-bottom 0px
    position relative
    display table

    @media $xxsmall

      font-size 14px

    i

      margin-right 8px

    span

      color $red

  &_filters

    max-width 390px
    margin auto auto
    width 100%

    @media $medium

      max-width none

    &_cta

      font-size: 14px;
      color: $blue
      appearance none
      border 0px
      border-top 1px solid $s2
      letter-spacing: 0;
      text-transform none!important
      text-align: center;
      font-family $f-title
      font-weight normal
      height 45px
      width 100%
      border-radius 17px
      height 35px
      background-color white
      cursor pointer

      &_open

        i

          transform rotate(180deg)

      i

        margin-left 5px
        transition 1s $ease

    &_choices

      padding 30px 20px
      box-sizing border-box
      width 100%

      @media $medium

        border-top 1px solid $s2

      &_reset

        appearance none
        display block
        background-color transparent
        color $s1
        font-size 14px
        text-align left
        cursor pointer
        border 0px
        padding 0px
        text-decoration underline

        @media $xsmall

          font-size 12px

        i

          margin-left 8px

      p

        font-family: $f-title
        font-weight 500
        font-size: 18px;
        color: $blue
        letter-spacing: -0.3px;
        text-align: left;
        line-height: 22px;


      &_field

        display flex
        flex-direction row
        width 100%
        flex-wrap wrap
        align-items stretch
        justify-content flex-start
        margin-bottom 5px

        @media $medium

          max-width 360px

        &:last-child

          margin-bottom 0px

        .Cta

          text-transform none!important
          font-size 14px
          background-color white

        &_buttons

          button[data-i="0"]

            margin-right 0px
            border-radius 17px 0px 0px 17px

          button[data-i="1"]

            margin-left 0px
            border-radius 0px 17px 17px 0px
            border-left 0px

        &_select

          position relative
          width 100%
          // max-width 285px

          select

            width 100%

          &_arrow

            position absolute
            top calc(50% - 2px)
            font-size 16px
            color $grey
            right 15px
            line-height 14px
            transform translateY(-50%)
            z-index 2
            transition color 0.4s $ease
            pointer-events none

          &_picto

            position absolute
            top 50%
            font-size 16px
            color $blue
            left 15px
            line-height 14px
            transform translateY(-50%)
            z-index 2
            transition color 0.4s $ease

          &_selected

            .FiltersBlockMobile_filters_choices_field_select_arrow, .FiltersBlockMobile_filters_choices_field_select_picto

              color white!important

        h5

          width 100%
          display block
          font-family: $f-title
          font-weight normal
          font-size: 14px;
          color: $blue
          margin-bottom 10px
          letter-spacing: 0;
          text-align: left;

        .vs__dropdown-menu

          max-height 100px

        .vs__selected-options, .vs__dropdown-toggle, .vs__selected-options input, .vs__selected-options input::placeholder, .vs__selected

          margin 0px
          padding 0px
          font-size: 14px;
          height 100%
          width 100%
          text-transform none
          color $blue
          border 0px
          background transparent

        .vs__dropdown-option

          font-size: 14px;
          text-transform none
          color $blue

        .vs__dropdown-option--highlight

          background-color $n2

        .vs__actions

          display none

        .Cta

          margin-right 10px
          margin-bottom 10px
          font-size: 14px;
          height 35px
          line-height 30px
          padding 0px 10px
          border-radius: 17px;
          text-transform none

          &_line

            border-color $s2
            min-width auto

            &:hover

              color $blue!important
              background-color white!important
              border-color $s2!important

          &_select

            margin-bottom 0px
            box-sizing border-box
            padding 0px 0px 0px 35px
            text-transform none

            &:hover

              background-color transparent!important

            &.Cta_selected

              color white!important

              .vs__selected-options, .vs__selected, .vs__search

                color white!important

          &_selected, &_selected:hover

            color white!important
            border-color $blue!important
            background-color $blue!important
            box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);
            opacity 1

          &:last-child

            margin-right 0px

  &_header

    width 100%
    max-width 590px
    box-sizing border-box
    margin auto
    margin-bottom 30px

    @media $medium

      padding 20px 20px 0px 20px
      display flex
      margin 0px
      flex-direction row
      align-items stretch
      justify-content flex-start
      margin-bottom 0px

    &_question

      font-family: $f-title;
      font-weight 500
      font-size: 18px;
      line-height: 22px;
      color: $blue
      text-align center
      letter-spacing: -0.3px;
      margin-top 30px

      @media $medium

        text-align left
        font-size: 14px;
        line-height: 17px;
        margin-top 0px

    &_count

      font-family: $f-title;
      font-weight 500
      font-size: 14px;
      color: $red
      display table
      letter-spacing: -0.16px;
      line-height: 14px;
      position relative
      padding-bottom 3px
      margin auto

      @media $medium

        margin 0px
        margin-right 25px
        top 8px

      &:before

        content ''
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -55%) rotate(-45deg)
        width 31px
        height 31px
        border 1px solid $red

        @media $medium

          height 21px
          width 21px



</style>
